/* eslint-disable react/prop-types */
import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import { TbClipboardText } from "react-icons/tb";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";

const ExamSidebar = ({ collapsed }) => {
  const { pathname } = useLocation();
  const mainPath = pathname?.split("/")[4];
  const defaultRoute =
    mainPath?.slice(0).charAt(0).toUpperCase() + mainPath?.slice(1);

  const { examId } = useParams();
  const refetchToggle = useSelector((state) => state.examSidebar.refetchToggle);

  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    ?.token.access;
  const [examData, setExamData] = useState([]);
  const swapSettingsQuestion = useSelector((state) => state.examSidebar.value);
  useEffect(() => {
    async function getExamData() {
      const url = `${apiUrl}/api/exam/admin/exam_question_paper/${examId}/`;

      const getData = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });

      setExamData(getData.data);
    }

    getExamData();
  }, [access_token, apiUrl, examId, refetchToggle]);
  let sidebarItems = [
    {
      key: "Settings",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/exam/${examId}/settings`}
          className="text-base font-semibold"
        >
          Settings
        </NavLink>
      ),
    },
    {
      key: "Questions",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/exam/${examId}/questions`}
          className="text-base font-semibold"
        >
          Questions
        </NavLink>
      ),
    },
    {
      key: "Publish",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/exam/${examId}/publish`}
          className="text-base font-semibold"
        >
          Publish
        </NavLink>
      ),
    },
    {
      key: "Leaderboard",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/exam/${examId}/leaderboard`}
          className="text-base font-semibold"
        >
          Result
        </NavLink>
      ),
    },
    // {
    //   key: "Share",
    //   icon: <TbClipboardText size={20} className="flex-shrink-0" />,
    //   label: (
    //     <NavLink
    //       to={`/admin/exam/${examId}/share`}
    //       className="text-base font-semibold"
    //     >
    //       Share
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: "omr",
    //   icon: toggleShuffle === false && (
    //     <TbClipboardText size={20} className={"flex-shrink-0"} />
    //   ),
    //   label: (
    //     <NavLink
    //       to={`/admin/exam/${examId}/omr`}
    //       className={`text-base font-semibold ${
    //         toggleShuffle === true && "hidden"
    //       }`}
    //     >
    //       Omr
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: "My Answer sheets",
    //   icon: <TbClipboardText size={20} className="flex-shrink-0" />,
    //   label: (
    //     <NavLink to={`/answer-sheet`} className="text-base font-semibold">
    //       My Answer sheets
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: "Performance",
    //   icon: <TbClipboardText size={20} className="flex-shrink-0" />,
    //   label: (
    //     <NavLink to={`/performance`} className="text-base font-semibold">
    //       Performance
    //     </NavLink>
    //   ),
    // },
  ];

  // Only show OMR menu when toggleShuffle is true
  if (examData?.is_offline === true) {
    sidebarItems.push({
      key: "omr",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/exam/${examId}/omr`}
          className="text-base font-semibold"
        >
          Omr
        </NavLink>
      ),
    });
  }

  if (examData?.is_cq === true) {
    sidebarItems.push({
      key: "cq",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/exam/${examId}/cq-evaluation`}
          className="text-base font-semibold"
        >
          CQ Check
        </NavLink>
      ),
    });
  }

  if (swapSettingsQuestion === true) {
    [sidebarItems[0], sidebarItems[1]] = [sidebarItems[1], sidebarItems[0]];
  }

  return (
    <Sider
      theme="light"
      trigger={null}
      collapsible
      collapsed={collapsed}
      width="250px"
      className="h-[calc(100vh-64px)]"
    >
      <Link
        to="/admin/exams"
        className="h-16 flex gap-2 items-center px-5 text-base"
      >
        <LiaAngleLeftSolid />
        All Exams
      </Link>
      <Menu
        mode="inline"
        defaultSelectedKeys={[defaultRoute]}
        items={sidebarItems}
        className="text-base font-semibold h-[calc(100%-64px)]"
      />
    </Sider>
  );
};

export default ExamSidebar;
